export default __webpack_public_path__ + "static/jaroslaw_k-38c6f8b0770bff3cc7e47375ebcf6079.png";